import React, {useEffect} from 'react'

import {Col, Container, Row, Table} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'

import {useContentWrapper} from '../common/ContentWrapperProvider'
import PublicLayout from '../common/PublicLayout'
import {StyledInfoPageHeaderWrapper} from '../common/styledComponents'

function GdprContentEn() {
    return (
        <>
            <p className="text-muted">
                pursuant to Articles 13 and 14 of Regulation (EU) 2016/679 of the European Parliament and of the Council
                on the protection of natural persons with regard to the processing of personal data and on the free movement
                of such data (hereinafter referred to as the &quot;Regulation&quot; or &quot;GDPR&quot;),
                in accordance with Section 19 of Act No. 18/2018 Coll. on the Protection of Personal Data
                (hereinafter referred to as the &quot;Act&quot;)
            </p>

            <h2 className="mt-4">1. Introductory Information</h2>
            <p>
                This information sets out the manner in which the company: <strong>The first million s. r. o.</strong>,
                Dolné Sľažany 317, 951 71 Sľažany, Company Registration No.: 54 616 913, registered in the Commercial Register
                of the District Court Nitra, Section: Sro, Insert No.: 60864/N
                (hereinafter referred to as the &quot;Controller&quot;), processes the personal data of data subjects
                in the course of providing its services.
            </p>
            <p>
                Should you have any questions or comments relating to the protection of your personal data,
                including the exercise of your rights under the Regulation and the Act, please contact us
                by telephone at: <strong>+421 948 944 724</strong> or by e-mail
                at: <a href="mailto:pomozemti@amani.sk"><strong>pomozemti@amani.sk</strong></a>
            </p>

            <h2 className="mt-4">2. Basic Definitions</h2>
            <p>
                <strong>Automated individual decision-making</strong> is a decision concerning data subjects
                made by means of technology and without any human intervention.
            </p>
            <p>
                <strong>A data subject</strong> is any natural person whose personal data are processed
                within our information systems.
            </p>
            <p>
                <strong>Personal data</strong> means any information relating to an identified or identifiable
                natural person, such as first name, surname, date of birth, personal identification number,
                permanent address, temporary address, and the like.
            </p>
            <p>
                <strong>Profiling</strong> is the automated processing of personal data involving the evaluation
                of personal aspects relating to a data subject in order to create predictions about that individual.
            </p>
            <p>
                <strong>Processing of personal data</strong> means any operation or set of operations performed
                on personal data or on sets of personal data, including collection, recording, organisation,
                structuring, storage, alteration, retrieval, consultation, use, disclosure by transmission,
                dissemination or otherwise making available, alignment or combination, restriction, erasure or
                destruction, regardless of whether such operations are carried out by automated or non-automated means.
            </p>
            <p>
                <strong>Purposes of processing personal data</strong> are the reasons for which the personal data
                of data subjects (employees, clients) are processed within our information systems on specifically
                defined legal bases. The purposes are specifically determined, explicitly stated and legitimate,
                and in processing the personal data of data subjects we adhere to the principle of lawfulness
                pursuant to Articles 6 and 9 of the Regulation (the individual purposes and legal bases are
                set out in the annex to this Privacy Policy).
            </p>

            {/* REGISTRATION / USER ACCOUNT */}
            <h2 className="mt-5">Registration / User Account</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is the performance of a contract.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Registration / User Account</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Performance of a contract pursuant to Article 6(1)(b) of the Regulation.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>Upon cancellation of the user account, the account is transferred to a restricted mode in which the user has no access to the application&apos;s features, but retains access solely to view issued invoices, for a period of 10 years following the end of the calendar year to which the invoice relates, in accordance with Section 35 of Act No. 431/2002 Coll. on Accounting and Section 76 of Act No. 222/2004 Coll. on Value Added Tax. After this 10-year statutory archiving period, or upon expiry of the period of use of the application, personal data will be permanently deleted, with the exception of data necessary to fulfil statutory archiving obligations under Act No. 395/2002 Coll. on Archives and Registries and on the Amendment of Certain Acts.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Users, clients of users.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, date of birth, gender, street, number, postcode, city, country, IBAN, telephone contact, e-mail, application password, social media passwords, website, profile photo, billing details entered by the user, invoices issued by the user.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects – users.</td>
                </tr>
                </tbody>
            </Table>

            <p className="mt-3">
                We merely provide application users with data storage space on our servers for the purpose of
                storing data entered by the user within the <strong>Amani</strong> application. However, you,
                as the user, are the controller of such data.
            </p>
            <p>
                In this regard, we hereby draw your attention to the fact that you are obliged to comply with all
                personal data protection rules set out in Regulation (EU) 2016/679 of the European Parliament and
                of the Council on the protection of natural persons with regard to the processing of personal data
                and on the free movement of such data, as well as in other legal regulations governing personal
                data protection. We bear no liability whatsoever for any breach of personal data protection rules
                on your part as a user. Upon discovering non-compliance with the rules governing personal data
                processing, we reserve the right to remove such personal data from our servers. Prior to the
                deletion of critical personal data, we will contact you with a request to remedy the situation.
            </p>
            <p>
                We do not perform any operations on your data as a user, including personal data — we do not modify,
                disclose, or transfer it to third parties (except for its disclosure to public authorities in accordance
                with the law), nor do we carry out any other operations. Such personal data is merely stored on our
                servers, and we do not interfere with it in any manner whatsoever. The sole purpose of handling this
                personal data is its storage and the ability to make it accessible to you — the users. At your request
                as a user, we are however able to perform data migration from another system, perform bulk data
                correction or data analysis, but always on the basis of a separate agreement.
            </p>
            <p>
                Your password will be stored with us in encrypted form. We are unable to read this password.{' '}
                <strong>In the event that you forget your password, you will be required to use the
                &quot;Forgot Password&quot; function, which will automatically send a newly generated password
                to your e-mail address.</strong>
            </p>
            <p>
                <strong>For the processing of your payments, we make use of the services of an external partner
                — a third party — GOPAY S.R.O.</strong> In accordance with the principle of data minimisation,
                we do not process, in any capacity, the payment instrument data which you provide exclusively
                to <strong>GOPAY S.R.O.</strong>
            </p>
            <p>
                Data stored on our servers is secured through the encryption of data transmissions by means of an SSL certificate.
            </p>

            {/* NEWSLETTER */}
            <h2 className="mt-5">Newsletter</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is the sending of information about our own products and services.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Newsletter</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>The data subject has given consent to the processing of their personal data pursuant to Article 6(1)(a) of the Regulation.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>For the duration of your newsletter subscription, or until the expiry of 3 years from the termination of newsletter distribution, in accordance with Act No. 395/2002 Coll. on Archives and Registries and on the Amendment of Certain Acts.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Natural persons who have given consent to receive the Newsletter, either by ticking the consent checkbox during registration in the application, or via a separate Newsletter sign-up form.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Salutation, title, first name, surname, e-mail.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects.</td>
                </tr>
                </tbody>
            </Table>
            <p className="mt-3">
                You may unsubscribe from the Newsletter at any time. Following your unsubscription, we will no longer
                send you the Newsletter and will cease to further process your personal data for this purpose.
                The unsubscribe link can be found at the bottom of each Newsletter, or you may contact us directly
                at <a href="mailto:pomozemti@amani.sk"><strong>pomozemti@amani.sk</strong></a>.
            </p>

            {/* SENDING OF GREETINGS */}
            <h2 className="mt-5">Sending of Greetings</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data is the sending of greetings on special occasions, such as birthdays, name days, and the most significant holidays of the year.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Sending of Greetings</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Legitimate interests pursuant to Article 6(1)(f) of the Regulation. The legitimate interest is the building of our good reputation.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>Upon expiry of the period of application use and the statutory archiving period pursuant to Act No. 395/2002 Coll.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Users.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, date of birth, e-mail.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects.</td>
                </tr>
                </tbody>
            </Table>

            {/* REGISTRY MANAGEMENT */}
            <h2 className="mt-5">Registry Management</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is registry management, encompassing proper record-keeping, the orderly disposal of files, ensuring the systematic scheduling of file disposal, and the recording of incoming and outgoing correspondence.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Registry Management</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Compliance with a legal obligation pursuant to Article 6(1)(c) of the Regulation; public interest pursuant to Article 6(1)(e) of the Regulation. Act of the National Council of the Slovak Republic No. 395/2002 Coll. on Archives and Registries; Act No. 305/2013 Coll. on the Electronic Form of the Exercise of Powers of Public Authorities.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>Public authority bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>Pursuant to Act No. 395/2002 Coll. on Archives and Registries.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Data subjects within the scope of all purposes of personal data processing as defined by the Controller.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Personal data within the scope of all purposes of personal data processing.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Sources within the scope of all purposes of personal data processing.</td>
                </tr>
                </tbody>
            </Table>

            {/* REGISTER OF SELF-EMPLOYED PERSONS */}
            <h2 className="mt-5">Register of Self-Employed Persons</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is the preparation and management of supplier-customer relationships with self-employed persons.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Register of Self-Employed Persons</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Performance of a contract pursuant to Article 6(1)(b) of the Regulation; compliance with a legal obligation pursuant to Article 6(1)(c) of the Regulation.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services; auditors; accountants.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>10 years following the termination of the contractual relationship, on account of records within the accounting agenda.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Customer/supplier – self-employed person.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, birth surname, permanent address, temporary address, place of business, registered business premises address, date of birth, personal identification number, telephone contact, e-mail, bank account number.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects, employees of data subjects.</td>
                </tr>
                </tbody>
            </Table>

            {/* REGISTER OF SUPPLIER AND CUSTOMER REPRESENTATIVES */}
            <h2 className="mt-5">Register of Supplier and Customer Representatives</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is the maintenance of a database of representatives and/or employees of suppliers and customers, for the purpose of fulfilling their occupational, official and functional duties and ensuring the smooth operation of supplier-customer relationships.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Register of Supplier and Customer Representatives</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Performance of a contract pursuant to Article 6(1)(b) of the Regulation. Section 78(3) of Act of the National Council of the Slovak Republic No. 18/2018 Coll. on the Protection of Personal Data.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services; auditors; accountants.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>10 years on account of records within the accounting agenda; otherwise for the duration of the limitation periods applicable to the exercise of the Controller&apos;s rights.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Natural person – representative (employee) of a supplier or customer.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, telephone contact, e-mail, job title, official designation, employee identification number, department, place of work, employer identification data.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects, employers of data subjects.</td>
                </tr>
                </tbody>
            </Table>

            {/* LEGAL RELATIONS */}
            <h2 className="mt-5">Legal Relations</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is to ensure the management of legal affairs (e.g. first-instance proceedings, handling of remedies, management of litigation, legal representation, enforcement of damage compensation decisions, recovery of damages, enforcement of contractual obligations, proposing measures with organisational and legal implications, etc.).</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Legal Relations</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Legitimate interests pursuant to Article 6(1)(f) of the Regulation. The legitimate interest is the establishment, exercise and defence of the Controller&apos;s legal claims in the event of a dispute.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>Courts, enforcement officers (bailiffs), notaries, state administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services; auditors; accountants.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>For the duration of the limitation periods applicable to the exercise of rights.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Data subjects within the scope of all purposes of personal data processing as defined by the Controller; debtors; opposing parties in disputes; other natural persons in the capacity of parties to proceedings; other involved persons.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, birth surname, permanent address, temporary address, nationality, place of business, date of birth, personal identification number, telephone contact, e-mail.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects, legal successors of data subjects, employers of data subjects, parties or participants in court, enforcement, arbitration or administrative proceedings, legal representatives of data subjects.</td>
                </tr>
                </tbody>
            </Table>

            {/* EXERCISE OF DATA SUBJECTS' RIGHTS */}
            <h2 className="mt-5">Exercise of Data Subjects&apos; Rights</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data within the scope of this agenda is the handling of requests from natural persons seeking to exercise their rights as data subjects pursuant to Regulation (EU) 2016/679 of the European Parliament and of the Council.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Exercise of Data Subjects&apos; Rights</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Compliance with a legal obligation pursuant to Article 6(1)(c) of the Regulation. Article 6(1)(a), in conjunction with Articles 15 to 22 and 34 of the Regulation.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>3 years from the date of the request being handled.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>A natural person who, as a data subject within the purposes defined by the Controller, approaches the Controller with a request to exercise their rights.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, permanent address, temporary address, date of birth, telephone contact, e-mail, and any other data necessary for the handling of the data subject&apos;s request.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects, legal successors.</td>
                </tr>
                </tbody>
            </Table>

            {/* FINANCIAL AND ACCOUNTING */}
            <h2 className="mt-5">Financial and Accounting Agenda</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data is the processing of orders, incoming invoices and the invoicing of customers, banking operations, cash management, management of cash receipts and expenditures, inventory management, records of capital and minor assets, and the maintenance of single-entry/double-entry bookkeeping.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Financial and Accounting</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Compliance with a legal obligation pursuant to Article 6(1)(c) of the Regulation. Act No. 431/2002 Coll. on Accounting; Act No. 222/2004 Coll. on Value Added Tax; Act No. 286/1992 Coll. on Income Tax; Act No. 563/2009 Coll. on Tax Administration (Tax Code); Act No. 311/2001 Coll. (Labour Code).</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>Processor engaged to perform the financial and accounting agenda; the Tax Authority; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; external lawyers or cooperating legal counsel; companies providing server or IT services; auditors; accountants; and other processors as applicable.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>Pursuant to Act No. 431/2002 Coll. on Accounting or the registry management schedule.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Suppliers and customers – natural persons; employees of suppliers and customers; representatives of suppliers and customers.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Title, first name, surname, birth surname, permanent address, temporary address, place of business, registered business premises address, date of birth, personal identification number, telephone contact, e-mail, bank account number, signature.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Data subjects.</td>
                </tr>
                </tbody>
            </Table>

            {/* SOFTWARE IMPROVEMENT */}
            <h2 className="mt-5">Software Improvement</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Purpose of Personal Data Processing</strong></td>
                    <td>The purpose of processing personal data is the improvement of software, its development, and the rectification of any potential errors.</td>
                </tr>
                <tr>
                    <td><strong>Name of Information System</strong></td>
                    <td>IS Software Improvement</td>
                </tr>
                <tr>
                    <td><strong>Legal Basis</strong></td>
                    <td>Legitimate interests pursuant to Article 6(1)(f) of the Regulation. The legitimate interest is the provision of high-quality software.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Recipients</strong></td>
                    <td>State administration, public authority and public administration bodies in accordance with applicable legislation; within the exercise of investigative powers: the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection, law enforcement authorities, and potentially other public authority bodies; companies providing server or IT services.</td>
                </tr>
                <tr>
                    <td><strong>Cross-border Transfer of Personal Data to Third Countries Outside the EEA</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Retention Periods for Personal Data Erasure</strong></td>
                    <td>Upon expiry of the period of application use and the statutory archiving period pursuant to Act No. 395/2002 Coll., or for the duration of the Controller&apos;s legitimate interest.</td>
                </tr>
                <tr>
                    <td><strong>Information on the Existence of Automated Decision-making, Including Profiling</strong></td>
                    <td>Does not take place.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Data Subjects</strong></td>
                    <td>Users, clients of users.</td>
                </tr>
                <tr>
                    <td><strong>Categories of Personal Data</strong></td>
                    <td>Personal data from the information system for registration/user account; the use of other data from other information systems is not excluded.</td>
                </tr>
                <tr>
                    <td><strong>Source</strong></td>
                    <td>Users.</td>
                </tr>
                </tbody>
            </Table>

            <p className="mt-4">
                Where the legal basis for the processing of personal data is the performance of a contract,
                the provision of such data constitutes a contractual requirement, and the Controller&apos;s knowledge
                thereof is necessary for the conclusion and performance of the contract. In the interest of concluding
                the contract, the data subject is obliged to provide the Controller with their personal data; failing
                to do so will preclude the conclusion of a contract with the Controller.
            </p>
            <p>
                Where the legal basis for the processing of personal data is a statutory requirement, the provision
                of such data constitutes a legal obligation. Failure to provide such data will render it impossible
                to ensure the proper fulfilment of our obligations arising from the relevant general legal regulations.
            </p>
            <p>
                We may, on the basis of a contract, commission third parties — so-called processors — to process
                your personal data. Such processors process personal data in accordance with our instructions and
                subject to the adoption of measures to ensure the security of your personal data.
            </p>
            <p>Our processors include, in particular:</p>
            <ul>
                <li>persons commissioned to carry out individual acts of legal services, representing or cooperating lawyers,</li>
                <li>our accountants or auditors as applicable,</li>
                <li>software solution providers, server and IT service providers.</li>
            </ul>
            <p>
                Within the exercise of investigative powers, we are obliged to disclose your personal data also
                to the Slovak Trade Inspection, the Tax Authority, the Office for Personal Data Protection,
                law enforcement authorities, or possibly other public authorities, if we are required to disclose
                such personal data in accordance with national law or European Union law.
            </p>

            {/* GOOGLE SERVICES */}
            <h2 className="mt-5">3. Recipients and Sharing of Data Obtained Through Google Services</h2>
            <p>
                Our application offers sign-in via a Google account and, in that context, accesses the Google Calendar
                service for the purpose of synchronising appointments and events (hereinafter &quot;Google Calendar Sync&quot;).
                Specifically, we use the following Google access scopes: auth/calendar, auth/userinfo.email and
                auth/userinfo.profile. Through these permissions, the application reads existing events in your
                Google Calendar (e.g. to display availability) and, at the same time, creates, modifies or deletes
                events in it (e.g. bookings, appointments). We also obtain basic identification data from your
                Google account (first name, surname, e-mail address).
            </p>
            <p>
                We do not permanently store your Google sign-in password or the content of your Google Calendar
                database — we store only an authorisation (access) token, which is used to verify our authorisation
                to access your calendar on behalf of the application. This token is stored securely and is used
                exclusively for calendar synchronisation within the application&apos;s functions. The data that Google
                makes available to us in this connection (hereinafter &quot;Google user data&quot;) is processed exclusively
                to the extent and for the purposes for which you granted consent at sign-in. We do not provide,
                share or otherwise transfer Google user data to third parties for advertising or marketing purposes.
            </p>
            <p>
                We may provide or disclose Google user data only to the following categories of recipients,
                and only to the extent necessary for the operation of the application:
            </p>
            <ul>
                <li>providers of hosting, server and IT services (the application is operated on Webglobe VPS servers), who ensure the operation and maintenance of the application and the database for us,</li>
                <li>providers of software and development services who participate in the development and operation of the application and are bound by a personal data processing agreement,</li>
                <li>public authorities, where required by law.</li>
            </ul>
            <p>
                We do not transfer Google user data to third countries outside the European Economic Area.
                The Controller complies with Google&apos;s Limited Use Policy and uses Google user data exclusively
                to provide or improve features visible to the user within the application, not for advertising
                or marketing purposes.
            </p>

            {/* SECURITY MEASURES */}
            <h2 className="mt-5">4. Protection of Sensitive Data and Security Measures</h2>
            <p>
                To protect personal data, including special categories of personal data (sensitive data) and
                sign-in data obtained through Google services, we apply in particular the following technical
                and organisational measures:
            </p>
            <ul>
                <li>encryption of data transmission via the HTTPS/TLS protocol,</li>
                <li>authentication and authorisation mechanisms to protect access to our APIs and interfaces (sign-in is secured through JWT tokens),</li>
                <li>secure storage of data in a protected PostgreSQL database,</li>
                <li>access-rights management ensuring that personal data can be accessed only by authorised individuals and services, based on the principle of least privilege,</li>
                <li>regular security updates, monitoring of systems, and adherence to established security best practices.</li>
            </ul>

            {/* DATA SUBJECT RIGHTS */}
            <h2 className="mt-5">5. What Are Your Rights as a Data Subject?</h2>

            <h3 className="mt-4">A. Right of Access</h3>
            <p>
                You have the right of access to your data. Upon your request, we will issue a confirmation as
                to whether personal data concerning you is being processed. Where such data is being processed,
                we will, upon request, provide the first copy of such personal data free of charge.
            </p>

            <h3 className="mt-4">B. Right to Rectification and Completion of Personal Data</h3>
            <p>
                You have the right to rectification of your personal data where we hold inaccurate records thereof.
                You also have the right to the completion of your incomplete personal data. Rectification or
                completion of personal data shall be carried out without undue delay following your request to do so.
            </p>

            <h3 className="mt-4">C. Right to Erasure</h3>
            <p>You have the right to erasure of your personal data concerning you, provided that:</p>
            <ul>
                <li>the personal data is no longer necessary for the purposes for which it was collected or otherwise processed,</li>
                <li>you withdraw the consent on the basis of which the processing was carried out,</li>
                <li>you object to the processing of personal data,</li>
                <li>the personal data has been processed unlawfully,</li>
                <li>the grounds for erasure are the fulfilment of an obligation under law, a special regulation or an international treaty by which the Slovak Republic is bound, or</li>
                <li>the personal data was collected in connection with the offer of information society services to a person under the age of 16.</li>
            </ul>
            <p>The right to erasure of personal data shall not apply where processing is necessary:</p>
            <ul>
                <li>for the exercise of the right to freedom of expression and information,</li>
                <li>for compliance with an obligation under law, a special regulation or an international treaty,</li>
                <li>on grounds of public interest in the area of public health,</li>
                <li>for archiving purposes in the public interest, for scientific or historical research purposes, or for statistical purposes,</li>
                <li>for the establishment, exercise or defence of legal claims.</li>
            </ul>
            <p>
                The Controller will erase your personal data at your request, without undue delay once it has
                assessed that your request is justified.
            </p>

            <h3 className="mt-4">D. Right to Restriction of Processing</h3>
            <p>You have the right to restriction of processing of personal data where:</p>
            <ul>
                <li>the accuracy of the personal data is contested, for a period enabling us to verify the accuracy of the personal data,</li>
                <li>the processing is unlawful and you request restriction of the use of your personal data rather than its erasure,</li>
                <li>we no longer need your personal data for the purposes of processing, but you require it for the establishment, exercise or defence of legal claims,</li>
                <li>you have objected to the processing of personal data on the basis of our legitimate interest, pending verification of whether our legitimate grounds override those of the data subject.</li>
            </ul>

            <h3 className="mt-4">E. Right to Data Portability</h3>
            <p>
                You have the right to data portability, meaning the right to receive the personal data you have
                provided to us, and the right to transmit such data to another controller in a commonly used and
                machine-readable format, provided that the personal data was obtained on the basis of your consent
                or on the basis of a contract, and that the processing is carried out by automated means.
            </p>

            <h3 className="mt-4">F. Right to Object to the Processing of Personal Data</h3>
            <p>
                You have the right to object at any time to the processing of your personal data on grounds
                relating to your particular situation. You may object to the processing of your personal data
                on the basis of:
            </p>
            <ul>
                <li>the legal title of the performance of tasks carried out in the public interest or in the exercise of official authority, or on the basis of our legitimate interest,</li>
                <li>the processing of personal data for the purposes of direct marketing,</li>
                <li>processing for the purposes of scientific or historical research or for statistical purposes.</li>
            </ul>
            <p>
                If you object to the processing of personal data for direct marketing purposes, we may no longer
                process your personal data.
            </p>
            <p>
                We will assess your objection within a reasonable time upon receipt. We may not continue processing
                your personal data unless we demonstrate compelling legitimate grounds for the processing which
                override your rights or interests, or grounds for the establishment, exercise or defence of a legal claim.
            </p>

            <h3 className="mt-4">G. Right to Withdraw Consent to the Processing of Personal Data at Any Time</h3>
            <p>
                You have the right to withdraw your consent to the processing of personal data at any time,
                where the processing of your personal data was based on this legal title. You may withdraw your
                consent by contacting the Controller in writing with your request by any means of your choosing.
                However, the withdrawal of consent shall not affect the lawfulness of processing carried out on
                the basis of the consent prior to its withdrawal.
            </p>

            <h3 className="mt-4">H. Right to Lodge a Complaint</h3>
            <p>
                You have the right to lodge a proposal to initiate proceedings (a complaint) with the Office for
                Personal Data Protection of the Slovak Republic, registered office: Hraničná 4826/12, 820 07 Bratislava,
                Slovak Republic, telephone number: +421 2 3231 3220,{' '}
                <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">www.dataprotection.gov.sk</a>,{' '}
                <a href="mailto:statny.dozor@pdp.gov.sk">statny.dozor@pdp.gov.sk</a>, if you consider that your rights
                in the area of personal data protection have been infringed. If a data subject does not have full
                legal capacity, their rights under the Regulation and the Act on the Protection of Personal Data
                may be exercised by their legal representative. The rights of a deceased data subject under the
                Regulation and the Act on the Protection of Personal Data may be exercised by a close person.
            </p>

            {/* HOW TO EXERCISE RIGHTS */}
            <h2 className="mt-5">6. How May You Exercise Your Rights as a Data Subject?</h2>
            <p>You may exercise your rights as a data subject in the following ways:</p>
            <ul>
                <li>by registered post sent to the address of our registered office: The first million s. r. o., Dolné Sľažany 317, 951 71 Sľažany,</li>
                <li>by e-mail to the following address: <a href="mailto:pomozemti@amani.sk">pomozemti@amani.sk</a></li>
            </ul>

            {/* CHANGES TO PRIVACY POLICY */}
            <h2 className="mt-5">7. Changes to the Privacy Policy</h2>
            <p>
                The protection of personal data is not, for us, a one-time matter. The information which we are
                obliged to provide to you in connection with our processing of personal data may change or cease
                to be current. For this reason, we reserve the right to amend and modify these terms and conditions
                at any time and to any extent. In the event of a material change to these terms and conditions,
                we will draw such a change to your attention, for example by means of a general notice on this
                website or by a specific notification sent by e-mail.
            </p>
        </>
    )
}

function GdprContentSk() {
    return (
        <>
            <p className="text-muted">
                podľa čl. 13 a 14 Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679
                o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe
                takýchto údajov (ďalej len &quot;Nariadenie&quot; alebo &quot;GDPR&quot;)
                v súlade s § 19 zákona č. 18/2018 Z.z. o ochrane osobných údajov
                (ďalej len &quot;Zákon&quot;)
            </p>

            <h2 className="mt-4">1. Úvodné informácie</h2>
            <p>
                Tieto informácie vysvetľujú akým spôsobom spoločnosť: <strong>The first million s. r. o.</strong>,
                Dolné Sľažany 317, 951 71 Sľažany, IČO: 54 616 913, zapísaná v Obchodnom registri
                Okresného súdu Nitra, Oddiel: Sro, Vložka číslo: 60864/N
                (ďalej len ako &quot;Prevádzkovateľ&quot;) spracúva osobné údaje dotknutých osôb
                pri poskytovaní svojich služieb.
            </p>
            <p>
                V prípade akýchkoľvek otázok či pripomienok súvisiacich s ochranou vašich osobných
                údajov vrátane uplatnenia vašich práv v zmysle Nariadenia a Zákona nás kontaktujte
                telefonicky na telefónnom čísle: <strong>+421 948 944 724</strong> alebo e-mailom
                na e-mailovej adrese: <a href="mailto:pomozemti@amani.sk"><strong>pomozemti@amani.sk</strong></a>
            </p>

            <h2 className="mt-4">2. Základné pojmy</h2>
            <p>
                <strong>Automatizované individuálne rozhodovanie</strong> je rozhodnutie o dotknutých
                osobách prijímané pomocou technológií a bez akéhokoľvek ľudského zásahu.
            </p>
            <p>
                <strong>Dotknutou osobou</strong> je každá fyzická osoba, ktorej osobné údaje sa
                v našich informačných systémoch spracúvajú.
            </p>
            <p>
                <strong>Osobné údaje</strong> sú akékoľvek údaje o fyzickej osobe, týkajúce sa
                identifikovanej alebo identifikovateľnej fyzickej osoby, napríklad meno, priezvisko,
                dátum narodenia, rodné číslo, adresa trvalého bydliska, adresa prechodného bydliska, a pod.
            </p>
            <p>
                <strong>Profilovanie</strong> je automatizované spracúvanie osobných údajov, pri
                ktorom sa hodnotia osobné vlastnosti dotknutej osoby na vytvorenie prognóz o nej.
            </p>
            <p>
                <strong>Spracúvanie osobných údajov</strong> je spracovateľská operácia alebo súbor
                spracovateľských operácií s osobnými údajmi alebo so súbormi osobných údajov,
                najmä získavanie, zaznamenávanie, usporadúvanie, štruktúrovanie, uchovávanie, zmena,
                vyhľadávanie, prehliadanie, využívanie, poskytovanie prenosom, šírením alebo iným
                spôsobom, preskupovanie alebo kombinovanie, obmedzenie, vymazanie, bez ohľadu na to,
                či sa vykonáva automatizovanými prostriedkami alebo neautomatizovanými prostriedkami.
            </p>
            <p>
                <strong>Účelmi spracúvania osobných údajov</strong> sú dôvody, pre ktoré sa spracúvajú
                osobné údaje dotknutých osôb (zamestnancov, klientov) v našich informačných systémoch
                na presne určených právnych základoch. Účely sú konkrétne určené, výslovne uvedené
                a oprávnené, pričom pri spracúvaní osobných údajov dotknutých osôb dodržiavame zásadu
                zákonnosti podľa článku 6 a 9 Nariadenia (jednotlivé účely a právne základy sú uvedené
                v prílohe týchto Zásad ochrany osobných údajov).
            </p>

            {/* REGISTRÁCIA / ÚČET POUŽÍVATEĽA */}
            <h2 className="mt-5">Registrácia / Účet používateľa</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je plnenie zmluvy</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Registrácia / Účet používateľa</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Plnenie zmluvy podľa čl. 6 ods. 1 písm. b) Nariadenia</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>Po zrušení používateľského účtu je účet prevedený do obmedzeného režimu, v ktorom používateľ nemá prístup k funkciám aplikácie, avšak zachováva sa mu prístup výlučne k prehliadaniu vystavených faktúr, a to po dobu 10 rokov nasledujúcich po skončení kalendárneho roka, ktorého sa faktúra týka, v súlade s § 35 zákona č. 431/2002 Z. z. o účtovníctve a § 76 zákona č. 222/2004 Z. z. o dani z pridanej hodnoty. Po uplynutí tejto 10-ročnej zákonnej archivačnej doby, prípadne po uplynutí doby využívania aplikácie, budú osobné údaje s výnimkou údajov nevyhnutných na plnenie zákonných archivačných povinností v zmysle zákona č. 395/2002 Z. z. o archívoch a registratúrach a o doplnení niektorých zákonov nenávratne vymazané.</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Používatelia, klienti používateľov</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, dátum narodenia, pohlavie, ulica, číslo, PSČ, mesto, krajina, IBAN, telefonický kontakt, e-mail, heslo do aplikácie, heslá na sociálne siete, web, fotka, fakturačné údaje vložené používateľom, faktúry vystavené používateľom</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby - používatelia</td>
                </tr>
                </tbody>
            </Table>

            <p className="mt-3">
                Používateľovi aplikácie len poskytujeme dátový priestor na našich serveroch na účely
                uloženia dát vkladaných používateľom v rámci aplikácie <strong>Amani</strong>. Správcom
                týchto údajov ste však vy, samotný používateľ.
            </p>
            <p>
                V tejto súvislosti Vás upozorňujeme, že ste povinný dodržiavať všetky pravidlá ochrany
                osobných údajov uvedené v Nariadení Európskeho parlamentu a Rady (EÚ) 2016/679
                o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto
                údajov a v ďalších právnych predpisoch upravujúcich ochranu osobných údajov. Nenesieme
                žiadnu zodpovednosť za porušenie pravidiel ochrany osobných údajov z Vašej strany ako
                používateľa. Pri zistení nedodržania pravidiel spracovania osobných údajov si vyhradzujeme
                právo takéto osobné údaje odstrániť zo svojich serverov. Pred zmazaním kritických osobných
                údajov Vás kontaktujeme so žiadosťou o nápravu.
            </p>
            <p>
                S Vašimi dátami ako používateľa vrátane osobných údajov nevykonávame žiadne operácie,
                teda nemeníme ich, nesprístupňujeme, neposkytujeme tretím osobám (okrem ich sprístupnenia
                štátnym orgánom v súlade so zákonom) a nevykonávame ani žiadne ďalšie operácie. Tieto
                osobné údaje sa len ukladajú na našich serveroch, pričom my do nich žiadnym spôsobom
                nezasahujeme. Jediným účelom nakladania s týmito osobnými údajmi je ich uchovávanie
                a možnosť ich sprístupnenia pre Vás - používateľov. Na Vašu žiadosť ako používateľa však
                vieme vykonať migráciu dát z iného systému, vykonať hromadnú opravu dát či dátovú analýzu,
                avšak to všetko na základe osobitnej zmluvy.
            </p>
            <p>
                Vaše heslo bude u nás uložené v šifrovanej podobe. Toto heslo nemôžeme prečítať.{' '}
                <strong>V prípade zabudnutého hesla tak budete musieť použiť funkciu
                &quot;Zabudnuté heslo,&quot; ktorá vám pošle automaticky vygenerované nové heslo e-mailom.</strong>
            </p>
            <p>
                <strong>Na spracovanie a vašich platieb využívame služby externého partnera – tretej strany
                – spoločnosti GOPAY S.R.O.</strong> V súlade so zásadou minimalizácie údajov nespracovávame
                v žiadnom rozsahu údaje o platobných prostriedkoch, ktoré poskytujete iba
                spoločnosti <strong>GOPAY S.R.O.</strong>
            </p>
            <p>
                Uložené dáta na našich serveroch sú zabezpečené šifrovaním dátových prenosov ssl certifikátom.
            </p>

            {/* NEWSLETTER */}
            <h2 className="mt-5">Newsletter</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je zasielanie informácií o vlastných produktoch a službách.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Newsletter</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Dotknutá osoba vyjadrila súhlas so spracúvaním svojich osobných údajov čl. 6 ods. 1 písm. a) Nariadenia</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>Po dobu, po ktorú budete prihlásení na odber Newslettra alebo do uplynutia 3 rokov od ukončenia zasielania Newslettra v súlade so zákonom č. 395/2002 Z. z. o archívoch a registratúrach a o doplnení niektorých zákonov</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Fyzická osoba, ktorá udelila súhlas so zasielaním Newslettra, a to buď zaškrtnutím súhlasu (checkbox) pri registrácii v aplikácii, alebo prostredníctvom samostatného formulára na odber Newslettra</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Oslovenie, titul, meno, priezvisko, e-mail</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby</td>
                </tr>
                </tbody>
            </Table>
            <p className="mt-3">
                Z odberu Newslettra sa môžete kedykoľvek odhlásiť. Po odhlásení Vám už nebudeme
                zasielať Newsletter a prestaneme ďalej spracúvať Vaše osobné údaje na tento účel.
                Link na odhlásenie odberu nájdete na konci každého Newslettera, alebo nás môžete priamo
                kontaktovať na <a href="mailto:pomozemti@amani.sk"><strong>pomozemti@amani.sk</strong></a>.
            </p>

            {/* ZASIELANIE BLAHOŽELANÍ */}
            <h2 className="mt-5">Zasielanie blahoželaní</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov je zasielanie blahoželaní pri osobitných príležitostiach, napr. narodeniny, meniny, najvýznamnejšie sviatky v roku.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Zasielanie blahoželaní</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Oprávnené záujmy podľa článku 6 ods. 1 písm. f) Nariadenia. Oprávneným záujmom je budovanie nášho dobrého mena.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>Po uplynutí doby využívania aplikácie a zákonného archivačného obdobia v zmysle zákona č. 395/2002 Z. z.</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Používatelia</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, dátum narodenia, e-mail</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby</td>
                </tr>
                </tbody>
            </Table>

            {/* SPRÁVA REGISTRATÚRY */}
            <h2 className="mt-5">Správa registratúry</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je správa registratúry ako riadna evidencia záznamov, riadne vyraďovanie spisov, zabezpečenie plánovitého vyraďovania spisov, evidencia došlej a odoslanej pošty.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Správa registratúry</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Plnenie zákonnej povinnosti podľa čl. 6 ods. 1 písm. c) Nariadenia, verejný záujem podľa čl. 6 ods. 1 písm. e) Nariadenia. Zákon NR SR č. 395/2002 Z. z. o archívoch a registratúrach, 305/2013 Z. z. o elektronickej podobe výkonu pôsobnosti orgánov verejnej moci.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány verejnej moci podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>V zmysle zákona č. 395/2002 Z.z. o archívoch a registratúrach</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Dotknuté osoby v rámci všetkých účelov spracúvania osobných údajov vymedzených prevádzkovateľom</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Osobné údaje v rámci všetkých účelov spracúvania osobných údajov</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Zdroje v rámci všetkých účelov spracúvania osobných údajov</td>
                </tr>
                </tbody>
            </Table>

            {/* EVIDENCIA SZČO */}
            <h2 className="mt-5">Evidencia SZČO</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je príprava a vedenie dodávateľsko-odberateľských vzťahov so samostatne zárobkovo činnými osobami.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>Evidencia SZČO</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Plnenie zmluvy podľa čl. 6 ods. 1 písm. b) Nariadenia, plnenie zákonnej povinnosti podľa čl. 6 ods. 1 písm. c) Nariadenia</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby, audítori, účtovníci.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>10 rokov po skončení zmluvného vzťahu z dôvodu evidencie v rámci účtovnej agendy</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Odberateľ/dodávateľ – samostatne zárobkovo činná osoba</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, rodné priezvisko, trvalý, prechodný pobyt, miesto podnikania, sídlo prevádzkarne, dátum narodenia, rodné číslo, telefonický kontakt, e-mail, číslo bankového účtu</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby, zamestnanci dotknutých osôb</td>
                </tr>
                </tbody>
            </Table>

            {/* EVIDENCIA ZÁSTUPCOV DODÁVATEĽOV A ODBERATEĽOV */}
            <h2 className="mt-5">Evidencia zástupcov dodávateľov a odberateľov</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je vedenie databázy zástupcov, respektíve zamestnancov dodávateľov a odberateľov z dôvodu plnenia ich pracovných, služobných a funkčných povinností a zabezpečenia plynulých dodávateľsko-odberateľských vzťahov.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>Evidencia zástupcov dodávateľov a odberateľov</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Plnenie zmluvy podľa čl. 6 ods. 1 písm. b) Nariadenia. § 78 od. 3 zákona NR SR č. 18/2018 Z. z. o ochrane osobných údajov.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby, audítori, účtovníci.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>10 rokov z dôvodu evidencie v rámci účtovnej agendy, inak počas trvania premlčacích dôb na uplatnenia práv prevádzkovateľa</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Fyzická osoba - zástupca (zamestnanec) dodávateľa, odberateľa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, telefonický kontakt, e-mail, pracovné zaradenie, služobné zaradenie, osobné číslo zamestnanca, odborný útvar, miesto výkonu práce, identifikačné údaje zamestnávateľa</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby, zamestnávatelia dotknutých osôb</td>
                </tr>
                </tbody>
            </Table>

            {/* PRÁVNE VZŤAHY */}
            <h2 className="mt-5">Právne vzťahy</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je zabezpečenie vedenia právnej agendy (napr. prvostupňové konanie, vybavovanie opravných prostriedkov, vybavovanie súdnych sporov, zastupovanie v právnych veciach, uplatňovanie rozhodnutí o náhradách škôd, vymáhanie náhrad škôd, uplatňovanie záväzkov zo zmlúv, navrhovanie opatrení s organizačno-právnym dosahom, atď.).</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Právne vzťahy</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Oprávnené záujmy podľa článku 6 ods. 1 písm. f) Nariadenia. Oprávneným záujmom je preukazovanie, uplatňovanie a obhajovanie právnych nárokov Prevádzkovateľa v prípade sporu.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Súdy, exekútori, notári, orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby, audítori, účtovníci.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>Počas plynutia premlčacích dôb na uplatnenie práv</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Dotknuté osoby v rámci všetkých účelov spracúvania osobných údajov vymedzených prevádzkovateľom, dlžníci, protistrany v sporoch, iné fyzické osoby v postavení účastníkov konania, ďalšie zúčastnené osoby.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, rodné priezvisko, trvalý, prechodný pobyt, štátna príslušnosť, miesto podnikania, dátum narodenia, rodné číslo, telefonický kontakt, e-mail</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby, právni nástupcovia dotknutých osôb, zamestnávatelia dotknutých osôb, strana, účastník konania v súdnom, exekučnom či rozhodcovskom alebo správnom konaní, právni zástupcovia dotknutých osôb</td>
                </tr>
                </tbody>
            </Table>

            {/* UPLATŇOVANIE PRÁV DOTKNUTÝCH OSÔB */}
            <h2 className="mt-5">Uplatňovanie práv dotknutých osôb</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov v rámci predmetnej agendy je vybavovanie žiadostí fyzických osôb smerujúcich k uplatňovaniu ich práv ako dotknutých osôb v zmysle Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Uplatňovanie práv dotknutých osôb</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Plnenie zákonnej povinnosti podľa čl. 6 ods. 1 písm. c) Nariadenia. Čl. 6, ods. 1, písm. a), v súlade s čl. 15 až 22 a 34 Nariadenia.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>3 roky odo dňa vybavenia žiadosti</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Fyzická osoba, ktorá sa ako dotknutá osoba v rámci prevádzkovateľom vymedzených účelov obráti na prevádzkovateľa so žiadosťou uplatniť svoje práva</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, trvalý, prechodný pobyt, dátum narodenia, telefonický kontakt, e-mail, prípadne iné údaje, ktoré sú nevyhnutné na vybavenie žiadosti dotknutej osoby</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby, právni nástupcovia</td>
                </tr>
                </tbody>
            </Table>

            {/* EKONOMICKO-ÚČTOVNÁ AGENDA */}
            <h2 className="mt-5">Ekonomicko-účtovná agenda</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov je spracúvanie objednávok, došlých faktúr a fakturácia odberateľom, styk s bankou, vedenie pokladne, zabezpečovanie hotovostných príjmov a výdavkov, skladové hospodárstvo, evidencia investičného majetku a drobného majetku, vedenie jednoduchého/podvojného účtovníctva organizácie.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Ekonomicko-účtovný</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Plnenie zákonnej povinnosti podľa článku 6 ods. 1 písm. c) Nariadenia. Zákon č. 431/2002 Z. z. o účtovníctve, zákon č. 222/2004 Z. z. o dani z pridanej hodnoty, zákon č. 286/1992 Zb. o dani z príjmov, zákon č. 563/2009 Z.z. o správe daní (daňový poriadok), zákon č. 311/2001 Z. z. Zákonník práce.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Sprostredkovateľ na výkon ekonomicko-účtovnej agendy, daňový úrad, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, externí advokáti alebo spolupracujúci právnici, prípadne spoločnosti poskytujúce serverové alebo IT služby a taktiež audítori či účtovníci, prípadne ďalší sprostredkovatelia.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>V zmysle zákona č. 431/2002 Z. z. o účtovníctve či registratúrneho poriadku.</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Dodávatelia a odberatelia – fyzické osoby, zamestnanci dodávateľov a odberateľov, zástupcovia dodávateľov a odberateľov</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Titul, meno, priezvisko, rodné priezvisko, trvalý, prechodný pobyt, miesto podnikania, sídlo prevádzkarne, dátum narodenia, rodné číslo, telefonický kontakt, e-mail, číslo bankového účtu, podpis</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Dotknuté osoby</td>
                </tr>
                </tbody>
            </Table>

            {/* VYLEPŠOVANIE SOFTWÉRU */}
            <h2 className="mt-5">Vylepšovanie softvéru</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel spracúvania osobných údajov</strong></td>
                    <td>Účelom spracúvania osobných údajov je zlepšovanie softvéru, jeho vývoj, odstraňovanie prípadných chýb.</td>
                </tr>
                <tr>
                    <td><strong>Názov informačného systému</strong></td>
                    <td>IS Vylepšovanie softvéru</td>
                </tr>
                <tr>
                    <td><strong>Právny základ</strong></td>
                    <td>Oprávnené záujmy podľa článku 6 ods. 1 písm. f) Nariadenia. Oprávneným záujmom je poskytovanie kvalitného softvéru.</td>
                </tr>
                <tr>
                    <td><strong>Kategórie príjemcov</strong></td>
                    <td>Orgány štátnej správy, verejnej moci a verejnej správy podľa príslušných právnych predpisov, v rámci výkonu vyšetrovacích právomocí Slovenská obchodná inšpekcia, daňový úrad, Úrad na ochranu osobných údajov, orgány činné v trestnom konaní, prípadne aj iný orgán verejnej moci, spoločnosti poskytujúce serverové alebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Cezhraničný prenos os. údajov do tretích krajín mimo EHP</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Lehoty na vymazanie os. údajov</strong></td>
                    <td>Po uplynutí doby využívania aplikácie a zákonného archivačného obdobia v zmysle zákona č. 395/2002 Z. z., resp. počas trvania oprávneného záujmu Prevádzkovateľa.</td>
                </tr>
                <tr>
                    <td><strong>Informácia o existencii automatizovaného rozhodovania vrátane profilovania</strong></td>
                    <td>Neuskutočňuje sa</td>
                </tr>
                <tr>
                    <td><strong>Kategórie dotknutých osôb</strong></td>
                    <td>Používatelia, klienti používateľov</td>
                </tr>
                <tr>
                    <td><strong>Kategórie osobných údajov</strong></td>
                    <td>Osobné údaje z informačného systému registrácia / účet používateľa, pričom nie je vylúčené využitie aj iných údajov z iných informačných systémov</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Používatelia</td>
                </tr>
                </tbody>
            </Table>

            <p className="mt-4">
                V prípade, ak je právnym základom pre spracovanie osobných údajov plnenie zmluvy,
                poskytnutie týchto údajov je zmluvnou požiadavkou a ich poznanie Prevádzkovateľom je
                potrebné na uzatvorenie a plnenie zmluvy. V záujme uzatvorenia zmluvy je dotknutá osoba
                povinná poskytnúť Prevádzkovateľovi osobné údaje, inak nebude môcť byť zmluva
                s Prevádzkovateľom uzatvorená.
            </p>
            <p>
                V prípade, ak je právnym základom pre spracovanie osobných údajov zákon, poskytnutie
                týchto údajov je zákonnou požiadavkou. V prípade neposkytnutia týchto údajov, nie je možné
                zabezpečiť riadne plnenie našich povinností, ktoré nám vyplývajú z príslušných všeobecných
                právnych predpisov.
            </p>
            <p>
                Spracúvaním Vašich osobných údajov môžeme na základe zmluvy poveriť tretie osoby, tzv.
                sprostredkovateľov, ktoré takéto osobné údaje spracúvajú podľa našich pokynov a za prijatia
                opatrení na to, aby Vaše osobné údaje boli v bezpečí.
            </p>
            <p>Našimi sprostredkovateľmi sú najmä:</p>
            <ul>
                <li>osoby, ktoré poverujeme vykonaním jednotlivých úkonov právnych služieb, zastupujúci alebo spolupracujúci advokáti,</li>
                <li>naši účtovníci či prípadne audítori,</li>
                <li>poskytovatelia softvérového vybavenia, poskytovatelia serverových a IT služieb.</li>
            </ul>
            <p>
                V rámci výkonu vyšetrovacích právomocí sme povinní poskytnúť Vaše osobné údaje aj Slovenskej
                obchodnej inšpekcii, daňovému úradu, Úradu na ochranu osobných údajov, orgánom činným v trestnom
                konaní, prípadne aj iným orgánom verejnej moci, ak budeme v súlade s vnútroštátnym právom,
                resp. v súlade s právom Európskej únie vyzvaní na poskytnutie týchto osobných údajov.
            </p>

            {/* SLUŽBY GOOGLE */}
            <h2 className="mt-5">3. Príjemcovia a zdieľanie údajov získaných prostredníctvom služieb Google</h2>
            <p>
                Naša aplikácia využíva prihlásenie prostredníctvom účtu Google a v jeho rámci pristupuje k službe
                Google Kalendár (Google Calendar) na účely synchronizácie termínov a udalostí (ďalej len
                &quot;Google Calendar Sync&quot;). Konkrétne používame nasledujúce prístupové oprávnenia (scopes)
                služby Google: auth/calendar, auth/userinfo.email a auth/userinfo.profile. Prostredníctvom týchto
                oprávnení aplikácia číta existujúce udalosti vo Vašom Google kalendári (napr. na zobrazenie
                dostupnosti) a zároveň v ňom vytvára, upravuje alebo maže udalosti (napr. rezervácie, termíny).
                Ďalej získavame základné identifikačné údaje z Vášho Google účtu (meno, priezvisko, e-mailová adresa).
            </p>
            <p>
                Z prihlásenia cez Google si u seba neukladáme Vaše prihlasovacie heslo ani obsah Vašej Google
                Kalendár databázy trvalo – ukladáme si výlučne autorizačný (prístupový) token, ktorý nám slúži
                na overenie oprávnenia pristupovať k Vášmu kalendáru v mene aplikácie. Tento token je uložený
                zabezpečene a používame ho výlučne na účel synchronizácie kalendára v rámci funkcií aplikácie.
                Údaje, ktoré nám Google v tejto súvislosti sprístupní (ďalej len &quot;Google user data&quot;),
                spracúvame výlučne v rozsahu a na účely, na ktoré ste nám udelili súhlas pri prihlásení.
                Google user data neposkytujeme, nezdieľame ani inak neprenášame tretím stranám na reklamné
                alebo marketingové účely.
            </p>
            <p>
                Google user data môžeme poskytnúť alebo sprístupniť iba nasledujúcim kategóriám príjemcov,
                a to výlučne v rozsahu nevyhnutnom na prevádzku aplikácie:
            </p>
            <ul>
                <li>poskytovateľom hostingu, serverových a IT služieb (aplikácia je prevádzkovaná na serveroch Webglobe VPS), ktorí pre nás zabezpečujú prevádzku a údržbu aplikácie a databázy,</li>
                <li>dodávateľom softvérových a vývojárskych služieb, ktorí sa podieľajú na vývoji a prevádzke aplikácie a sú viazaní zmluvou o spracúvaní osobných údajov,</li>
                <li>orgánom verejnej moci, ak nám to vyplýva zo zákonnej povinnosti.</li>
            </ul>
            <p>
                Google user data neprenášame do tretích krajín mimo Európskeho hospodárskeho priestoru.
                Prevádzkovateľ dodržiava Zásady obmedzeného použitia (Limited Use) spoločnosti Google
                a používa Google user data výlučne na poskytovanie alebo zlepšovanie funkcií viditeľných
                pre používateľa v rámci aplikácie, nie na účely reklamy či marketingu.
            </p>

            {/* BEZPEČNOSTNÉ OPATRENIA */}
            <h2 className="mt-5">4. Ochrana citlivých údajov a bezpečnostné opatrenia</h2>
            <p>
                Na ochranu osobných údajov, vrátane osobitných kategórií osobných údajov (citlivých údajov)
                a prihlasovacích údajov získaných prostredníctvom služieb Google, uplatňujeme najmä
                nasledovné technické a organizačné opatrenia:
            </p>
            <ul>
                <li>šifrovanie prenosu údajov prostredníctvom protokolu HTTPS/TLS,</li>
                <li>mechanizmy autentifikácie a autorizácie na ochranu prístupu k našim API a rozhraniam (prihlasovanie je zabezpečené prostredníctvom JWT tokenov),</li>
                <li>bezpečné uloženie údajov v chránenej databáze PostgreSQL,</li>
                <li>riadenie prístupových práv, ktoré umožňuje prístup k osobným údajom iba oprávneným osobám a službám na základe zásady najmenších privilégií,</li>
                <li>pravidelné bezpečnostné aktualizácie, monitorovanie systémov a dodržiavanie osvedčených bezpečnostných postupov.</li>
            </ul>

            {/* PRÁVA DOTKNUTEJ OSOBY */}
            <h2 className="mt-5">5. Aké máte práva ako dotknutá osoba?</h2>

            <h3 className="mt-4">A. Právo na prístup</h3>
            <p>
                Máte právo na prístup k svojim údajom. Na základe Vašej žiadosti vystavíme potvrdenie
                o tom, či sa spracúvajú Vaše osobné údaje, ktoré sa Vás týkajú. Pokiaľ tieto údaje
                spracúvame, vystavíme na základe žiadosti bezplatne prvú kópiu týchto Vašich osobných údajov.
            </p>

            <h3 className="mt-4">B. Právo na opravu a doplnenie osobných údajov</h3>
            <p>
                Máte právo na opravu Vašich osobných údajov, pokiaľ o ich evidujeme nesprávne. Zároveň
                máte právo na doplnenie Vašich neúplných osobných údajov. Opravu, prípadne doplnenie
                osobných údajov vykonáme bez zbytočného odkladu po tom, čo nás o to požiadate.
            </p>

            <h3 className="mt-4">C. Právo na vymazanie</h3>
            <p>Máte právo na vymazanie Vašich osobných údajov, ktoré sa Vás týkajú, za predpokladu, že:</p>
            <ul>
                <li>osobné údaje už nie sú potrebné na účely, na ktoré sa získavali alebo inak spracúvali,</li>
                <li>odvoláte súhlas, na základe ktorého sa spracúvanie vykonáva,</li>
                <li>namietate voči spracúvaniu osobných údajov,</li>
                <li>osobné údaje sa spracúvali nezákonne,</li>
                <li>je dôvodom pre výmaz splnenie povinnosti zákona, osobitného predpisu alebo medzinárodnej zmluvy, ktorou je Slovenská republika viazaná, alebo</li>
                <li>osobné údaje sa získavali v súvislosti s ponukou služieb informačnej spoločnosti osobe mladšej ako 16 rokov.</li>
            </ul>
            <p>Právo na výmaz osobných údajov nebudete mať za predpokladu, že je ich spracúvanie potrebné:</p>
            <ul>
                <li>na uplatnenie práva na slobodu prejavu a na informácie,</li>
                <li>na splnenie povinnosti podľa zákona, osobitného predpisu alebo medzinárodnej zmluvy,</li>
                <li>z dôvodov verejného záujmu v oblasti verejného zdravia,</li>
                <li>na účely archivácie vo verejnom záujme, na účely vedeckého alebo historického výskumu či na štatistické účely,</li>
                <li>na preukazovanie, uplatňovanie alebo obhajovanie právnych nárokov.</li>
            </ul>
            <p>
                Prevádzkovateľ vykoná výmaz Vašich osobných údajov na základe Vašej žiadosti, a to bez zbytočného
                odkladu po tom, čo vyhodnotí, že Vaša žiadosť je dôvodná.
            </p>

            <h3 className="mt-4">D. Právo na obmedzenie spracúvania</h3>
            <p>Máte právo na obmedzenie spracúvania osobných údajov, pokiaľ:</p>
            <ul>
                <li>napadne správnosť osobných údajov námietkou, a to počas obdobia umožňujúceho nám overiť správnosť osobných údajov,</li>
                <li>spracúvanie je protizákonné a žiadate namiesto výmazu osobných údajov obmedzenie ich použitia,</li>
                <li>Vaše osobné údaje už nepotrebujeme na účely spracúvania, ale potrebujete ich vy na preukázanie, uplatňovanie alebo obhajovanie právnych nárokov,</li>
                <li>namietate voči spracúvaniu osobných údajov na základe nášho oprávneného nároku, a to až do overenia, či oprávnené dôvody na našej strane prevažujú nad oprávnenými dôvodmi dotknutej osoby.</li>
            </ul>

            <h3 className="mt-4">E. Právo na prenosnosť údajov</h3>
            <p>
                Máte právo na prenosnosť údajov, čo znamená získanie osobných údajov, ktoré ste nám
                poskytli, pričom máte právo preniesť tieto údaje ďalšiemu prevádzkovateľovi v bežne
                používateľnom a strojovo čitateľnom formáte za predpokladu, že osobné údaje boli získané
                na základe Vášho súhlasu alebo na základe zmluvy a ich spracovanie prebieha formou
                automatizovaných prostriedkov.
            </p>

            <h3 className="mt-4">F. Právo namietať voči spracúvaniu osobných údajov</h3>
            <p>
                Máte právo kedykoľvek namietať voči spracúvaniu Vašich osobných údajov z dôvodov
                týkajúcich sa Vašej konkrétnej situácie. Môžete namietať spracúvanie Vašich osobných
                údajov na základe:
            </p>
            <ul>
                <li>právneho titulu plnenia úloh realizovaných vo verejnom záujme alebo pri výkone verejnej moci, alebo z právneho titulu nášho oprávneného záujmu,</li>
                <li>spracúvania osobných údajov na účely priameho marketingu,</li>
                <li>spracovania na účely vedeckého či historického výskumu alebo na štatistické účely.</li>
            </ul>
            <p>
                Pokiaľ namietnete spracúvanie osobných údajov na účely priameho marketingu, Vaše osobné údaje
                nemôžeme ďalej spracúvať.
            </p>
            <p>
                Vašu doručenú námietku v primeranom čase posúdime. Nesmieme ďalej spracúvať Vaše osobné údaje,
                ak nepreukážeme nevyhnutné oprávnené záujmy na spracúvanie osobných údajov, ktoré prevažujú
                nad Vašimi právami alebo záujmami, alebo dôvody na uplatnenie právneho nároku.
            </p>

            <h3 className="mt-4">G. Právo kedykoľvek odvolať svoj súhlas so spracúvaním osobných údajov</h3>
            <p>
                Máte právo kedykoľvek odvolať svoj súhlas so spracovaním osobných údajov, pokiaľ bolo
                spracúvanie Vašich osobných údajov založené na tomto právnom titule. Svoj súhlas odvoláte
                písomným kontaktovaním Prevádzkovateľa so svojou požiadavkou akýmkoľvek zvoleným
                spôsobom. Zákonnosť spracúvania osobných údajov na základe udeleného súhlasu však nie
                je jeho odvolaním dotknutá.
            </p>

            <h3 className="mt-4">H. Právo podať sťažnosť</h3>
            <p>
                Máte právo podať návrh na začatie konania (sťažnosť) Úradu na ochranu osobných údajov
                Slovenskej republiky, so sídlom Hraničná 4826/12, 820 07 Bratislava, Slovenská republika,
                telefónne číslo: +421 2 3231 3220, <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">www.dataprotection.gov.sk</a>,{' '}
                <a href="mailto:statny.dozor@pdp.gov.sk">statny.dozor@pdp.gov.sk</a>, pokiaľ sa
                domnievate, že boli porušené Vaše práva v oblasti ochrany osobných údajov. Ak dotknutá osoba
                nemá spôsobilosť na právne úkony v plnom rozsahu, jej práva v zmysle Nariadenia a zákona
                o ochrane osobných údajov môže uplatniť zákonný zástupca. Práva dotknutej osoby v zmysle
                Nariadenia a zákona o ochrane osobných údajov, ktorá nežije, môže uplatniť blízka osoba.
            </p>

            {/* UPLATNENIE PRÁV */}
            <h2 className="mt-5">6. Akým spôsobom môžete uplatniť vaše práva dotknutej osoby?</h2>
            <p>Vaše práva dotknutej osoby si môžete uplatniť nasledovnými spôsobmi:</p>
            <ul>
                <li>doporučenou poštovou zásielkou zaslanou na adresu nášho sídla: The first million s. r. o., Dolné Sľažany 317, 951 71 Sľažany,</li>
                <li>e-mailom na emailovú adresu: <a href="mailto:pomozemti@amani.sk">pomozemti@amani.sk</a></li>
            </ul>

            {/* ZMENY PODMIENOK */}
            <h2 className="mt-5">7. Zmeny podmienok ochrany súkromia</h2>
            <p>
                Ochrana osobných údajov pre nás nie je jednorazovou záležitosťou. Informácie, ktoré sme
                vám povinní vzhľadom na naše spracúvanie osobných údajov poskytnúť, sa môžu meniť alebo
                prestať byť aktuálne. Z tohto dôvodu si vyhradzujeme možnosť kedykoľvek tieto podmienky
                upraviť a zmeniť v akomkoľvek rozsahu. V prípade zmeny týchto podmienok podstatným
                spôsobom Vám zmenu dáme do pozornosti napr. všeobecným oznámením na tejto webovej
                stránke alebo osobitným oznámením prostredníctvom emailu.
            </p>
        </>
    )
}

function GdprContentCs() {
    return (
        <>
            <p className="text-muted">
                podle čl. 13 a 14 Nařízení Evropského parlamentu a Rady (EU) 2016/679 o ochraně fyzických
                osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů
                (dále jen &quot;Nařízení&quot; nebo &quot;GDPR&quot;), v souladu s § 19 slovenského zákona
                č. 18/2018 Z. z. o ochraně osobních údajů (dále jen &quot;Zákon&quot;)
            </p>
            <p className="text-muted">
                (Tento dokument je českým překladem zásad ochrany osobních údajů, které se řídí právním
                řádem Slovenské republiky, neboť společnost je usazena a poskytuje služby ze Slovenské republiky.)
            </p>

            <h2 className="mt-4">1. Úvodní informace</h2>
            <p>
                Tyto informace vysvětlují, jakým způsobem společnost <strong>The first million s. r. o.</strong>,
                se sídlem Dolné Sľažany 317, 951 71 Sľažany, Slovenská republika, IČO: 54 616 913, zapsaná
                v Obchodním rejstříku Okresního soudu Nitra, Oddíl: Sro, Vložka číslo: 60864/N
                (dále jen &quot;Správce&quot;), zpracovává osobní údaje subjektů údajů při poskytování svých služeb.
            </p>
            <p>
                V případě jakýchkoli dotazů či připomínek souvisejících s ochranou vašich osobních údajů,
                včetně uplatnění vašich práv ve smyslu Nařízení a Zákona, nás kontaktujte telefonicky
                na telefonním čísle: <strong>+421 948 944 724</strong> nebo e-mailem na e-mailové
                adrese: <a href="mailto:pomozemti@amani.sk"><strong>pomozemti@amani.sk</strong></a>
            </p>

            <h2 className="mt-4">2. Základní pojmy</h2>
            <p>
                <strong>Automatizované individuální rozhodování</strong> je rozhodnutí o subjektech údajů
                přijímané pomocí technologií a bez jakéhokoli lidského zásahu.
            </p>
            <p>
                <strong>Subjektem údajů</strong> je každá fyzická osoba, jejíž osobní údaje jsou v našich
                informačních systémech zpracovávány.
            </p>
            <p>
                <strong>Osobní údaje</strong> jsou jakékoli údaje o fyzické osobě týkající se identifikované
                nebo identifikovatelné fyzické osoby, například jméno, příjmení, datum narození, rodné číslo,
                adresa trvalého bydliště, adresa přechodného pobytu apod.
            </p>
            <p>
                <strong>Profilování</strong> je automatizované zpracování osobních údajů, při kterém se hodnotí
                osobní vlastnosti subjektu údajů za účelem vytvoření prognóz o něm.
            </p>
            <p>
                <strong>Zpracování osobních údajů</strong> je zpracovatelská operace nebo soubor zpracovatelských
                operací s osobními údaji nebo se soubory osobních údajů, zejména získávání, zaznamenávání,
                uspořádávání, strukturování, uchovávání, změna, vyhledávání, nahlížení, využívání, poskytování
                přenosem, šířením nebo jiným způsobem, přeskupování nebo kombinování, omezení, výmaz, bez ohledu
                na to, zda se provádí automatizovanými či neautomatizovanými prostředky.
            </p>
            <p>
                <strong>Účely zpracování osobních údajů</strong> jsou důvody, pro které se zpracovávají osobní
                údaje subjektů údajů (zaměstnanců, klientů) v našich informačních systémech na přesně určených
                právních základech. Účely jsou konkrétně určeny, výslovně uvedeny a oprávněné, přičemž při
                zpracování osobních údajů subjektů údajů dodržujeme zásadu zákonnosti podle článku 6 a 9
                Nařízení (jednotlivé účely a právní základy jsou uvedeny v příloze těchto Zásad ochrany
                osobních údajů).
            </p>

            {/* REGISTRACE / ÚČET UŽIVATELE */}
            <h2 className="mt-5">Registrace / Účet uživatele</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je plnění smlouvy</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Registrace / Účet uživatele</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Plnění smlouvy podle čl. 6 odst. 1 písm. b) Nařízení</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Po zrušení uživatelského účtu je účet převeden do omezeného režimu, ve kterém uživatel nemá přístup k funkcím aplikace, avšak zachovává se mu přístup výhradně k prohlížení vystavených faktur, a to po dobu 10 let následujících po skončení kalendářního roku, kterého se faktura týká, v souladu s § 35 slovenského zákona č. 431/2002 Z. z. o účetnictví a § 76 slovenského zákona č. 222/2004 Z. z. o dani z přidané hodnoty. Po uplynutí této desetileté zákonné archivační doby, případně po uplynutí doby využívání aplikace, budou osobní údaje s výjimkou údajů nezbytných ke splnění zákonných archivačních povinností podle slovenského zákona č. 395/2002 Z. z. o archivech a registraturách a o doplnění některých zákonů nenávratně vymazány.</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Uživatelé, klienti uživatelů</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, datum narození, pohlaví, ulice, číslo, PSČ, město, země, IBAN, telefonický kontakt, e-mail, heslo do aplikace, hesla na sociální sítě, web, fotka, fakturační údaje vložené uživatelem, faktury vystavené uživatelem</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů - uživatelé</td>
                </tr>
                </tbody>
            </Table>

            <p className="mt-3">
                Uživateli aplikace pouze poskytujeme datový prostor na našich serverech za účelem uložení dat
                vkládaných uživatelem v rámci aplikace <strong>Amani</strong>. Správcem těchto údajů jste však
                vy, samotný uživatel.
            </p>
            <p>
                V této souvislosti vás upozorňujeme, že jste povinni dodržovat všechna pravidla ochrany osobních
                údajů uvedená v Nařízení Evropského parlamentu a Rady (EU) 2016/679 o ochraně fyzických osob
                v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů, a v dalších právních
                předpisech upravujících ochranu osobních údajů. Neneseme žádnou odpovědnost za porušení pravidel
                ochrany osobních údajů z vaší strany jako uživatele. Při zjištění nedodržení pravidel zpracování
                osobních údajů si vyhrazujeme právo takové osobní údaje odstranit ze svých serverů. Před smazáním
                kritických osobních údajů vás budeme kontaktovat se žádostí o nápravu.
            </p>
            <p>
                S vašimi daty jako uživatele, včetně osobních údajů, neprovádíme žádné operace, tedy je neměníme,
                nezpřístupňujeme, neposkytujeme třetím osobám (kromě jejich zpřístupnění státním orgánům v souladu
                se zákonem) a neprovádíme ani žádné další operace. Tyto osobní údaje se pouze ukládají na našich
                serverech, přičemž do nich nijak nezasahujeme. Jediným účelem nakládání s těmito osobními údaji
                je jejich uchovávání a možnost jejich zpřístupnění pro vás – uživatele. Na vaši žádost jako
                uživatele však umíme provést migraci dat z jiného systému, provést hromadnou opravu dat či
                datovou analýzu, avšak to vše na základě samostatné smlouvy.
            </p>
            <p>
                Vaše heslo bude u nás uloženo v šifrované podobě. Toto heslo nemůžeme přečíst.{' '}
                <strong>V případě zapomenutého hesla tak budete muset použít funkci &quot;Zapomenuté heslo&quot;,
                která vám pošle automaticky vygenerované nové heslo e-mailem.</strong>
            </p>
            <p>
                <strong>Ke zpracování vašich plateb využíváme služby externího partnera – třetí strany –
                společnosti GOPAY S.R.O.</strong> V souladu se zásadou minimalizace údajů nezpracováváme
                v žádném rozsahu údaje o platebních prostředcích, které poskytujete pouze
                společnosti <strong>GOPAY S.R.O.</strong>
            </p>
            <p>
                Uložená data na našich serverech jsou zabezpečena šifrováním datových přenosů SSL certifikátem.
            </p>

            {/* NEWSLETTER */}
            <h2 className="mt-5">Newsletter</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je zasílání informací o vlastních produktech a službách.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Newsletter</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Subjekt údajů vyjádřil souhlas se zpracováním svých osobních údajů, čl. 6 odst. 1 písm. a) Nařízení</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Po dobu, po kterou budete přihlášeni k odběru Newsletteru, nebo do uplynutí 3 let od ukončení zasílání Newsletteru, v souladu se slovenským zákonem č. 395/2002 Z. z. o archivech a registraturách a o doplnění některých zákonů</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Fyzická osoba, která udělila souhlas se zasíláním Newsletteru, a to buď zaškrtnutím souhlasu (checkbox) při registraci v aplikaci, nebo prostřednictvím samostatného formuláře pro odběr Newsletteru</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Oslovení, titul, jméno, příjmení, e-mail</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů</td>
                </tr>
                </tbody>
            </Table>
            <p className="mt-3">
                Z odběru Newsletteru se můžete kdykoli odhlásit. Po odhlášení vám již nebudeme zasílat Newsletter
                a přestaneme dále zpracovávat vaše osobní údaje k tomuto účelu. Odkaz na odhlášení odběru naleznete
                na konci každého Newsletteru, nebo nás můžete přímo
                kontaktovat na <a href="mailto:pomozemti@amani.sk"><strong>pomozemti@amani.sk</strong></a>.
            </p>

            {/* ZASÍLÁNÍ BLAHOPŘÁNÍ */}
            <h2 className="mt-5">Zasílání blahopřání</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů je zasílání blahopřání při zvláštních příležitostech, např. narozeniny, svátky, nejvýznamnější svátky v roce.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Zasílání blahopřání</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Oprávněné zájmy podle článku 6 odst. 1 písm. f) Nařízení, oprávněným zájmem je budování naší dobré pověsti.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Po uplynutí doby využívání aplikace a zákonné archivační doby podle slovenského zákona č. 395/2002 Z. z. o archivech a registraturách a o doplnění některých zákonů (lhůty uvedeny podle spisového a skartačního řádu)</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Uživatelé</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, datum narození, e-mail</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů</td>
                </tr>
                </tbody>
            </Table>

            {/* SPRÁVA REGISTRATURY */}
            <h2 className="mt-5">Správa registratury (spisové služby)</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je správa registratury jako řádná evidence záznamů (vedení úplné a přesné evidence záznamů v podacím deníku, vedení rejstříků a indexů záznamů), řádné vyřazování spisů (záznamů), zajištění plánovitého vyřazování spisů (záznamů), které již nejsou potřebné pro další činnost a uplynuly lhůty jejich uložení, evidence došlé a odeslané pošty.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Správa registratury</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Plnění zákonné povinnosti podle čl. 6 odst. 1 písm. c) Nařízení, veřejný zájem podle čl. 6 odst. 1 písm. e) Nařízení. Slovenský zákon č. 395/2002 Z. z. o archivech a registraturách, zákon č. 305/2013 Z. z. o elektronické podobě výkonu působnosti orgánů veřejné moci a o změně a doplnění některých zákonů (zákon o e-Governmentu).</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány veřejné moci podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Ve smyslu slovenského zákona č. 395/2002 Z. z. o archivech a registraturách</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Subjekty údajů v rámci všech účelů zpracování osobních údajů vymezených správcem</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Osobní údaje v rámci všech účelů zpracování osobních údajů</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Zdroje v rámci všech účelů zpracování osobních údajů</td>
                </tr>
                </tbody>
            </Table>

            {/* EVIDENCE OSVČ */}
            <h2 className="mt-5">Evidence OSVČ</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je příprava a vedení dodavatelsko-odběratelských vztahů s osobami samostatně výdělečně činnými. V rámci této agendy jsou vedeny smluvní vztahy, faktury a objednávky, evidence dodávek a odběrů zboží, služeb apod.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>Evidence OSVČ</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Plnění smlouvy podle čl. 6 odst. 1 písm. b) Nařízení, plnění zákonné povinnosti podle čl. 6 odst. 1 písm. c) Nařízení. Související právní předpisy: Smlouva mezi správcem a OSVČ, dovolená Ústavou Slovenské republiky, občanským zákoníkem, obchodním zákoníkem, slovenským zákonem č. 455/1991 Sb., zákonem o živnostenském podnikání (živnostenský zákon) a souvisejícími právními předpisy.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby, auditoři, účetní</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>10 let po skončení smluvního vztahu z důvodu evidence v rámci účetní agendy</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Odběratel/dodavatel – osoba samostatně výdělečně činná</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, rodné příjmení, trvalý, přechodný pobyt, místo podnikání, sídlo provozovny, datum narození, rodné číslo, telefonický kontakt, e-mail, číslo bankovního účtu</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů, zaměstnanci subjektů údajů</td>
                </tr>
                </tbody>
            </Table>

            {/* EVIDENCE ZÁSTUPCŮ DODAVATELŮ A ODBĚRATELŮ */}
            <h2 className="mt-5">Evidence zástupců dodavatelů a odběratelů</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je vedení databáze zástupců, respektive zaměstnanců dodavatelů a odběratelů z důvodu plnění jejich pracovních, služebních a funkčních povinností a zajištění plynulých dodavatelsko-odběratelských vztahů.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>Evidence zástupců dodavatelů a odběratelů</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Plnění smlouvy podle čl. 6 odst. 1 písm. b) Nařízení. Související právní předpis: § 78 odst. 3 slovenského zákona č. 18/2018 Z. z. o ochraně osobních údajů a o změně a doplnění některých zákonů</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby, auditoři, účetní</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>10 let z důvodu evidence v rámci účetní agendy, jinak po dobu trvání promlčecích dob k uplatnění práv správce</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Fyzická osoba – zástupce (zaměstnanec) dodavatele, odběratele</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, telefonický kontakt, e-mail, pracovní zařazení, služební zařazení, osobní číslo zaměstnance, odborný útvar, místo výkonu práce, identifikační údaje zaměstnavatele</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů, zaměstnavatelé subjektů údajů</td>
                </tr>
                </tbody>
            </Table>

            {/* PRÁVNÍ VZTAHY */}
            <h2 className="mt-5">Právní vztahy</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je zajištění vedení právní agendy (např. řízení v prvním stupni, vyřizování opravných prostředků, vyřizování soudních sporů, zastupování v právních věcech, uplatňování rozhodnutí o náhradách škod, vymáhání náhrad škod, uplatňování závazků ze smluv, navrhování opatření s organizačně-právním dosahem atd.).</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Právní vztahy</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Oprávněné zájmy podle článku 6 odst. 1 písm. f) Nařízení, oprávněným zájmem je prokazování, uplatňování a obhajoba právních nároků správce v případě sporu.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Soudy, exekutoři, notáři, orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby, auditoři, účetní</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Po dobu trvání promlčecích dob k uplatnění práv</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Subjekty údajů v rámci všech účelů zpracování osobních údajů vymezených správcem, dlužníci, protistrany ve sporech, jiné fyzické osoby v postavení účastníků řízení, další zúčastněné osoby.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, rodné příjmení, trvalý, přechodný pobyt, státní příslušnost, místo podnikání, datum narození, rodné číslo, telefonický kontakt, e-mail</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů, právní nástupci subjektů údajů, zaměstnavatelé subjektů údajů, strana, účastník řízení v soudním, exekučním či rozhodčím nebo správním řízení, právní zástupci subjektů údajů</td>
                </tr>
                </tbody>
            </Table>

            {/* UPLATŇOVÁNÍ PRÁV SUBJEKTŮ ÚDAJŮ */}
            <h2 className="mt-5">Uplatňování práv subjektů údajů</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů v rámci této agendy je vyřizování žádostí fyzických osob směřujících k uplatňování jejich práv jako subjektů údajů ve smyslu Nařízení Evropského parlamentu a Rady (EU) 2016/679.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Uplatňování práv subjektů údajů</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Plnění zákonné povinnosti podle čl. 6 odst. 1 písm. c) Nařízení. Čl. 6 odst. 1 písm. a), v souladu s čl. 15 až 22 a 34 Nařízení.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby.</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>3 roky ode dne vyřízení žádosti</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Fyzická osoba, která se jako subjekt údajů v rámci správcem vymezených účelů obrátí na správce se žádostí o uplatnění svých práv</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, trvalý, přechodný pobyt, datum narození, telefonický kontakt, e-mail, případně jiné údaje nezbytné k vyřízení žádosti subjektu údajů</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů, právní nástupci</td>
                </tr>
                </tbody>
            </Table>

            {/* EKONOMICKO-ÚČETNÍ AGENDA */}
            <h2 className="mt-5">Ekonomicko-účetní agenda</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů je zpracování objednávek, došlých faktur a fakturace odběratelům, styk s bankou, vedení pokladny, zajišťování hotovostních příjmů a výdajů, skladové hospodářství, evidence investičního majetku (včetně automatického odpisování) a drobného majetku, vedení jednoduchého/podvojného účetnictví organizace.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Ekonomicko-účetní</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Plnění zákonné povinnosti podle článku 6 odst. 1 písm. c) Nařízení. Související právní předpisy: slovenský zákon č. 431/2002 Z. z. o účetnictví, zákon č. 222/2004 Z. z. o dani z přidané hodnoty, zákon č. 286/1992 Sb. o dani z příjmů, zákon č. 563/2009 Z. z. o správě daní (daňový řád), zákon č. 311/2001 Z. z. Zákoník práce.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Zpracovatel pro výkon ekonomicko-účetní agendy, finanční úřad, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, externí advokáti nebo spolupracující právníci, případně společnosti poskytující serverové nebo IT služby, a rovněž auditoři či účetní, případně další zpracovatelé.</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Ve smyslu slovenského zákona č. 431/2002 Z. z. o účetnictví či spisového a skartačního řádu.</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Dodavatelé a odběratelé – fyzické osoby, zaměstnanci dodavatelů a odběratelů, zástupci dodavatelů a odběratelů</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Titul, jméno, příjmení, rodné příjmení, trvalý, přechodný pobyt, místo podnikání, sídlo provozovny, datum narození, rodné číslo, telefonický kontakt, e-mail, číslo bankovního účtu, podpis</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Subjekty údajů</td>
                </tr>
                </tbody>
            </Table>

            {/* VYLEPŠOVÁNÍ SOFTWARU */}
            <h2 className="mt-5">Vylepšování softwaru</h2>
            <Table bordered responsive className="mt-3">
                <tbody>
                <tr>
                    <td><strong>Účel zpracování osobních údajů</strong></td>
                    <td>Účelem zpracování osobních údajů je zlepšování softwaru, jeho vývoj, odstraňování případných chyb.</td>
                </tr>
                <tr>
                    <td><strong>Název informačního systému</strong></td>
                    <td>IS Vylepšování softwaru</td>
                </tr>
                <tr>
                    <td><strong>Právní základ</strong></td>
                    <td>Oprávněné zájmy podle článku 6 odst. 1 písm. f) Nařízení, oprávněným zájmem je poskytování kvalitního softwaru.</td>
                </tr>
                <tr>
                    <td><strong>Kategorie příjemců</strong></td>
                    <td>Orgány státní správy, veřejné moci a veřejné správy podle příslušných právních předpisů, v rámci výkonu vyšetřovacích pravomocí Slovenská obchodní inspekce, finanční úřad, Úřad na ochranu osobních údajů, orgány činné v trestním řízení, případně i jiný orgán veřejné moci, společnosti poskytující serverové nebo IT služby</td>
                </tr>
                <tr>
                    <td><strong>Přeshraniční přenos osobních údajů do třetích zemí mimo EHP</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Lhůta pro výmaz osobních údajů</strong></td>
                    <td>Po uplynutí doby využívání aplikace a zákonné archivační doby podle slovenského zákona č. 395/2002 Z. z. o archivech a registraturách a o doplnění některých zákonů, případně po dobu trvání oprávněného zájmu správce.</td>
                </tr>
                <tr>
                    <td><strong>Informace o existenci automatizovaného rozhodování včetně profilování</strong></td>
                    <td>Neuskutečňuje se</td>
                </tr>
                <tr>
                    <td><strong>Kategorie subjektů údajů</strong></td>
                    <td>Uživatelé, klienti uživatelů</td>
                </tr>
                <tr>
                    <td><strong>Kategorie osobních údajů</strong></td>
                    <td>Osobní údaje z informačního systému registrace / účet uživatele, přičemž není vyloučeno využití i jiných údajů z jiných informačních systémů</td>
                </tr>
                <tr>
                    <td><strong>Zdroj</strong></td>
                    <td>Uživatelé</td>
                </tr>
                </tbody>
            </Table>

            <p className="mt-4">
                V případě, že právním základem pro zpracování osobních údajů je plnění smlouvy, je poskytnutí
                těchto údajů smluvním požadavkem a jejich znalost správcem je nezbytná pro uzavření a plnění
                smlouvy. V zájmu uzavření smlouvy je subjekt údajů povinen poskytnout správci osobní údaje,
                jinak nebude možné smlouvu se správcem uzavřít.
            </p>
            <p>
                V případě, že právním základem pro zpracování osobních údajů je zákon, je poskytnutí těchto
                údajů zákonným požadavkem. V případě neposkytnutí těchto údajů není možné zajistit řádné
                plnění našich povinností vyplývajících z příslušných obecně závazných právních předpisů.
            </p>
            <p>
                Zpracováním vašich osobních údajů můžeme na základě smlouvy pověřit třetí osoby, tzv.
                zpracovatele, kteří takové osobní údaje zpracovávají podle našich pokynů a při přijetí
                opatření k tomu, aby vaše osobní údaje byly v bezpečí.
            </p>
            <p>Naši zpracovatelé jsou zejména:</p>
            <ul>
                <li>osoby, které pověřujeme prováděním jednotlivých úkonů právních služeb, zastupující nebo spolupracující advokáti,</li>
                <li>naši účetní či případně auditoři,</li>
                <li>poskytovatelé softwarového vybavení, poskytovatelé serverových a IT služeb.</li>
            </ul>
            <p>
                V rámci výkonu vyšetřovacích pravomocí jsme povinni poskytnout vaše osobní údaje i Slovenské
                obchodní inspekci, finančnímu úřadu, Úřadu na ochranu osobních údajů, orgánům činným v trestním
                řízení, případně i jiným orgánům veřejné moci, pokud k tomu budeme v souladu s vnitrostátním
                právem, resp. s právem Evropské unie vyzváni.
            </p>

            {/* SLUŽBY GOOGLE */}
            <h2 className="mt-5">3. Příjemci a sdílení údajů získaných prostřednictvím služeb Google</h2>
            <p>
                Naše aplikace využívá přihlášení prostřednictvím účtu Google a v jeho rámci přistupuje ke službě
                Google Kalendář (Google Calendar) za účelem synchronizace termínů a událostí (dále jen
                &quot;Google Calendar Sync&quot;). Konkrétně používáme následující přístupová oprávnění (scopes)
                služby Google: auth/calendar, auth/userinfo.email a auth/userinfo.profile. Prostřednictvím těchto
                oprávnění aplikace čte existující události ve vašem Google kalendáři (např. pro zobrazení
                dostupnosti) a zároveň v něm vytváří, upravuje nebo maže události (např. rezervace, termíny).
                Dále získáváme základní identifikační údaje z vašeho Google účtu (jméno, příjmení, e-mailová adresa).
            </p>
            <p>
                Z přihlášení přes Google si u sebe neukládáme vaše přihlašovací heslo ani obsah vaší databáze
                Google Kalendáře trvale – ukládáme si výhradně autorizační (přístupový) token, který nám slouží
                k ověření oprávnění přistupovat k vašemu kalendáři jménem aplikace. Tento token je uložen
                zabezpečeně a používáme ho výhradně za účelem synchronizace kalendáře v rámci funkcí aplikace.
                Údaje, které nám Google v této souvislosti zpřístupní (dále jen &quot;Google user data&quot;),
                zpracováváme výhradně v rozsahu a k účelům, ke kterým jste nám udělili souhlas při přihlášení.
                Google user data neposkytujeme, nesdílíme ani jinak nepřenášíme třetím stranám k reklamním
                nebo marketingovým účelům.
            </p>
            <p>
                Google user data můžeme poskytnout nebo zpřístupnit pouze následujícím kategoriím příjemců,
                a to výhradně v rozsahu nezbytném pro provoz aplikace:
            </p>
            <ul>
                <li>poskytovatelům hostingu, serverových a IT služeb (aplikace je provozována na serverech Webglobe VPS), kteří pro nás zajišťují provoz a údržbu aplikace a databáze,</li>
                <li>dodavatelům softwarových a vývojářských služeb, kteří se podílejí na vývoji a provozu aplikace a jsou vázáni smlouvou o zpracování osobních údajů,</li>
                <li>orgánům veřejné moci, pokud nám to vyplývá ze zákonné povinnosti.</li>
            </ul>
            <p>
                Google user data nepřenášíme do třetích zemí mimo Evropský hospodářský prostor. Správce dodržuje
                Zásady omezeného použití (Limited Use) společnosti Google a používá Google user data výhradně
                k poskytování nebo zlepšování funkcí viditelných pro uživatele v rámci aplikace, nikoli k účelům
                reklamy či marketingu.
            </p>

            {/* BEZPEČNOSTNÍ OPATŘENÍ */}
            <h2 className="mt-5">4. Ochrana citlivých údajů a bezpečnostní opatření</h2>
            <p>
                K ochraně osobních údajů, včetně zvláštních kategorií osobních údajů (citlivých údajů)
                a přihlašovacích údajů získaných prostřednictvím služeb Google, uplatňujeme zejména
                následující technická a organizační opatření:
            </p>
            <ul>
                <li>šifrování přenosu údajů prostřednictvím protokolu HTTPS/TLS,</li>
                <li>mechanismy autentizace a autorizace na ochranu přístupu k našim API a rozhraním (přihlašování je zabezpečeno prostřednictvím JWT tokenů),</li>
                <li>bezpečné uložení údajů v chráněné databázi PostgreSQL,</li>
                <li>řízení přístupových práv, které umožňuje přístup k osobním údajům pouze oprávněným osobám a službám na základě zásady nejmenších privilegií,</li>
                <li>pravidelné bezpečnostní aktualizace, monitorování systémů a dodržování osvědčených bezpečnostních postupů.</li>
            </ul>

            {/* PRÁVA SUBJEKTU ÚDAJŮ */}
            <h2 className="mt-5">5. Jaká máte práva jako subjekt údajů?</h2>

            <h3 className="mt-4">A. Právo na přístup</h3>
            <p>
                Máte právo na přístup ke svým údajům. Na základě vaší žádosti vystavíme potvrzení o tom,
                zda se zpracovávají vaše osobní údaje, které se vás týkají. Pokud tyto údaje zpracováváme,
                vystavíme na základě žádosti bezplatně první kopii těchto vašich osobních údajů.
            </p>

            <h3 className="mt-4">B. Právo na opravu a doplnění osobních údajů</h3>
            <p>
                Máte právo na opravu vašich osobních údajů, pokud je evidujeme nesprávně. Zároveň máte právo
                na doplnění vašich neúplných osobních údajů. Opravu, případně doplnění osobních údajů provedeme
                bez zbytečného odkladu poté, co nás o to požádáte.
            </p>

            <h3 className="mt-4">C. Právo na výmaz</h3>
            <p>Máte právo na výmaz vašich osobních údajů, které se vás týkají, za předpokladu, že:</p>
            <ul>
                <li>osobní údaje již nejsou potřebné pro účely, pro které se získávaly nebo jinak zpracovávaly,</li>
                <li>odvoláte souhlas, na základě kterého se zpracování provádí,</li>
                <li>namítáte proti zpracování osobních údajů,</li>
                <li>osobní údaje se zpracovávaly protiprávně,</li>
                <li>důvodem pro výmaz je splnění povinnosti podle zákona, zvláštního předpisu nebo mezinárodní smlouvy, kterou je Slovenská republika vázána, nebo</li>
                <li>osobní údaje se získávaly v souvislosti s nabídkou služeb informační společnosti osobě mladší 16 let.</li>
            </ul>
            <p>Právo na výmaz osobních údajů nebudete mít za předpokladu, že je jejich zpracování nezbytné:</p>
            <ul>
                <li>pro uplatnění práva na svobodu projevu a na informace,</li>
                <li>pro splnění povinnosti podle zákona, zvláštního předpisu nebo mezinárodní smlouvy, kterou je Slovenská republika vázána, nebo pro splnění úkolu prováděného ve veřejném zájmu či při výkonu veřejné moci svěřené správci,</li>
                <li>z důvodů veřejného zájmu v oblasti veřejného zdraví,</li>
                <li>pro účely archivace ve veřejném zájmu, pro účely vědeckého nebo historického výzkumu či pro statistické účely,</li>
                <li>pro prokazování, uplatňování nebo obhajobu právních nároků.</li>
            </ul>
            <p>
                Správce provede výmaz vašich osobních údajů na základě vaší žádosti, a to bez zbytečného
                odkladu poté, co vyhodnotí, že vaše žádost je důvodná.
            </p>

            <h3 className="mt-4">D. Právo na omezení zpracování</h3>
            <p>Máte právo na omezení zpracování osobních údajů, pokud:</p>
            <ul>
                <li>napadnete správnost osobních údajů námitkou, a to po dobu umožňující nám ověřit správnost osobních údajů,</li>
                <li>zpracování je protizákonné a žádáte místo výmazu osobních údajů omezení jejich použití,</li>
                <li>vaše osobní údaje již nepotřebujeme pro účely zpracování, ale potřebujete je vy pro prokazování, uplatňování nebo obhajobu právních nároků,</li>
                <li>namítáte proti zpracování osobních údajů na základě našeho oprávněného zájmu, a to až do ověření, zda oprávněné důvody na naší straně převažují nad oprávněnými důvody subjektu údajů.</li>
            </ul>

            <h3 className="mt-4">E. Právo na přenositelnost údajů</h3>
            <p>
                Máte právo na přenositelnost údajů, což znamená získání osobních údajů, které jste nám poskytli,
                přičemž máte právo přenést tyto údaje dalšímu správci v běžně používaném a strojově čitelném
                formátu, za předpokladu, že osobní údaje byly získány na základě vašeho souhlasu nebo na základě
                smlouvy a jejich zpracování probíhá formou automatizovaných prostředků.
            </p>

            <h3 className="mt-4">F. Právo namítat proti zpracování osobních údajů</h3>
            <p>
                Máte právo kdykoli namítat proti zpracování vašich osobních údajů z důvodů týkajících se vaší
                konkrétní situace. Můžete namítat zpracování vašich osobních údajů na základě:
            </p>
            <ul>
                <li>právního titulu plnění úkolů prováděných ve veřejném zájmu nebo při výkonu veřejné moci, nebo z právního titulu našeho oprávněného zájmu,</li>
                <li>zpracování osobních údajů pro účely přímého marketingu,</li>
                <li>zpracování pro účely vědeckého či historického výzkumu nebo pro statistické účely.</li>
            </ul>
            <p>
                Pokud namítnete zpracování osobních údajů pro účely přímého marketingu, vaše osobní údaje
                nemůžeme dále zpracovávat.
            </p>
            <p>
                Vaši doručenou námitku v přiměřené době posoudíme. Nesmíme dále zpracovávat vaše osobní údaje,
                pokud neprokážeme nezbytné oprávněné zájmy na zpracování osobních údajů, které převažují nad
                vašimi právy nebo zájmy, nebo důvody pro uplatnění právního nároku.
            </p>

            <h3 className="mt-4">G. Právo kdykoli odvolat svůj souhlas se zpracováním osobních údajů</h3>
            <p>
                Máte právo kdykoli odvolat svůj souhlas se zpracováním osobních údajů, pokud bylo zpracování
                vašich osobních údajů založeno na tomto právním titulu. Svůj souhlas odvoláte písemným
                kontaktováním správce se svým požadavkem jakýmkoli zvoleným způsobem. Zákonnost zpracování
                osobních údajů na základě uděleného souhlasu však není jeho odvoláním dotčena.
            </p>

            <h3 className="mt-4">H. Právo podat stížnost</h3>
            <p>
                Máte právo podat návrh na zahájení řízení (stížnost) Úřadu na ochranu osobních údajů Slovenské
                republiky, se sídlem Hraničná 4826/12, 820 07 Bratislava, Slovenská republika, telefonní číslo:
                +421 2 3231 3220,{' '}
                <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">www.dataprotection.gov.sk</a>,{' '}
                <a href="mailto:statny.dozor@pdp.gov.sk">statny.dozor@pdp.gov.sk</a>, pokud se domníváte,
                že byla porušena vaše práva v oblasti ochrany osobních údajů. Pokud subjekt údajů nemá plnou
                způsobilost k právním úkonům, jeho práva ve smyslu Nařízení a zákona o ochraně osobních údajů
                může uplatnit zákonný zástupce. Práva zesnulého subjektu údajů ve smyslu Nařízení a zákona
                o ochraně osobních údajů může uplatnit osoba blízká.
            </p>

            {/* UPLATNĚNÍ PRÁV */}
            <h2 className="mt-5">6. Jakým způsobem můžete uplatnit svá práva subjektu údajů?</h2>
            <p>Svá práva subjektu údajů si můžete uplatnit následujícími způsoby:</p>
            <ul>
                <li>doporučenou poštovní zásilkou zaslanou na adresu našeho sídla: The first million s. r. o., Dolné Sľažany 317, 951 71 Sľažany, Slovenská republika,</li>
                <li>e-mailem na e-mailovou adresu: <a href="mailto:pomozemti@amani.sk">pomozemti@amani.sk</a></li>
            </ul>

            {/* ZMĚNY PODMÍNEK */}
            <h2 className="mt-5">7. Změny podmínek ochrany soukromí</h2>
            <p>
                Ochrana osobních údajů pro nás není jednorázovou záležitostí. Informace, které jsme vám povinni
                vzhledem k našemu zpracování osobních údajů poskytnout, se mohou měnit nebo přestat být aktuální.
                Z tohoto důvodu si vyhrazujeme možnost kdykoli tyto podmínky upravit a změnit v jakémkoli rozsahu.
                V případě podstatné změny těchto podmínek vám změnu dáme na vědomí například obecným oznámením
                na těchto webových stránkách nebo zvláštním oznámením prostřednictvím e-mailu.
            </p>
        </>
    )
}

function GdprPage() {
    const contentWrapper = useContentWrapper()
    const {i18n} = useTranslation()

    const isEn = i18n.language === 'en'
    const isCs = i18n.language === 'cs'

    const title = isEn
        ? 'General Information on the Processing of Personal Data'
        : isCs
            ? 'Všeobecné informace o zpracování osobních údajů'
            : 'Všeobecné informácie o spracúvaní osobných údajov'

    useEffect(() => {
        contentWrapper.setNoBootstrapColumns(true)

        return () => {
            contentWrapper.setNoBootstrapColumns(false)
        }
    }, [])

    return (
        <PublicLayout>
            <div className="info-page">
                <StyledInfoPageHeaderWrapper>
                    <Container>
                        <Row>
                            <Col>
                                <h1>{title}</h1>
                            </Col>
                        </Row>
                    </Container>
                </StyledInfoPageHeaderWrapper>
                <Container>
                    <div className="rounded-content-body mt-3 p-4">
                        <Row>
                            <Col>
                                {isEn ? <GdprContentEn/> : isCs ? <GdprContentCs/> : <GdprContentSk/>}
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </PublicLayout>
    )
}


export default GdprPage
